import styled from 'styled-components';

export const Container = styled.div`
  padding: 8px 0;
  max-height: 600px;
  overflow-y: auto;
`;

export const EventoCard = styled.div`
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
`;

export const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 500;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  padding: 4px 0;
`;

export const InfoLabel = styled.span`
  font-weight: 600;
  color: #666;
  min-width: 150px;
  font-size: 0.875rem;
`;

export const InfoValue = styled.span`
  color: #333;
  text-align: right;
  flex: 1;
  font-size: 0.875rem;
  word-break: break-word;
`;

export const MensagemBox = styled.div`
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  border-left: 4px solid #2196f3;
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
`;

